export default __webpack_public_path__ + "static/tabletBackground-67d0ad611b6370729de93b75ec070ab0.jpg";